"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = selectAll;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defs = _interopRequireDefault(require("./_core/defs"));

var _dom = _interopRequireDefault(require("./_dom"));

var _selectnodes = _interopRequireDefault(require("./bindnode/_selectnodes"));

var _toarray = _interopRequireDefault(require("./_helpers/toarray"));

var _checkobjecttype = _interopRequireDefault(require("./_helpers/checkobjecttype"));

var _foreach = _interopRequireDefault(require("./_helpers/foreach"));

var customSelectorTestReg = /:sandbox|:bound\(([^(]*)\)/; // selects nodes based on given selector

function selectAll(object, selector) {
  if ((0, _typeof2["default"])(this) === 'object' && this.isSeemple) {
    // when context is Seemple instance, use this as an object and shift other args

    /* eslint-disable no-param-reassign */
    selector = object;
    object = this;
    /* eslint-enable no-param-reassign */
  } else {
    // throw error when object type is wrong
    (0, _checkobjecttype["default"])(object, 'selectAll or $');
  } // the selector includes "custom" things like :sandbox or :bound(KEY)


  if (customSelectorTestReg.test(selector)) {
    return (0, _selectnodes["default"])(object, selector);
  }

  var def = _defs["default"].get(object);

  var result = _dom["default"].$();

  if (!def || typeof selector !== 'string') {
    return result;
  }

  var propDef = def.props.sandbox;

  if (!propDef) {
    return result;
  }

  var bindings = propDef.bindings;

  if (bindings) {
    // iterate over all bindings and add found nodes
    (0, _foreach["default"])(bindings, function (_ref) {
      var node = _ref.node;
      var selected = node.querySelectorAll(selector);
      result = result.add((0, _toarray["default"])(selected));
    });
  }

  return result;
}
//# sourceMappingURL=selectall.js.map